import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import React from 'react';
import App from './App.tsx'
import './index.css'
import './i18n'
import { clearFeatureFlagCache } from '@/contexts/FeatureFlagContext';

// Initialize Sentry
Sentry.init({
  dsn: "https://e2f6fbce86e6ec0de6710ac689a26109@o4509970036097025.ingest.us.sentry.io/4509970037342208",
  environment: import.meta.env.MODE,
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  profilesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  enableLogs: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.consoleLoggingIntegration({ 
      levels: ["log", "warn", "error"] 
    }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation: () => ({ pathname: window.location.pathname }),
      useNavigationType: () => 'PUSH' as const,
      createRoutesFromChildren: (children: any) => [],
      matchRoutes: () => null,
    }),
  ],
  replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
});

// Verify Sentry is working in development
if (!import.meta.env.PROD) {
  console.log('Sentry initialized successfully');
  
  // Test connectivity to Sentry
  Sentry.addBreadcrumb({
    message: 'Sentry integration test',
    level: 'info',
    category: 'sentry-test',
  });

  // Expose feature flag debug helper
  (window as any).clearFeatureFlags = clearFeatureFlagCache;
  console.log('💡 Debug: Use window.clearFeatureFlags() to force re-evaluation of feature flags');
}

createRoot(document.getElementById("root")!).render(<App />);
